import { useLocation } from "react-router";
import AgentMenu from "./agentMenu/AgentMenu";
import ScribeMenu from "./scribeMenu/ScribeMenu";
import "./Headers.scss";
import ProvidersMenu from "./ProvidersMenu";
import ProviderMenuVideo from "./ProviderMenuVideo";
import NurseMenu from "./nurseMenu/NurseMenu";

const MenuLists = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(window.location.search);
  const isMeragoAI = queryParams.get("meragoai") === "true";


  return (
    // <>
    //   {location?.pathname.includes("agent") ? (
    //     <AgentMenu />
    //   ) : location?.pathname.includes("nurse") ? (
    //     <NurseMenu />
    //   ) : (
    //     <>
    //       {/* {isMeragoAI && <ProviderMenuVideo />} */}
    //       <ProvidersMenu />
    //     </>


    <>
      {location?.pathname.includes("agent") ? (
        <AgentMenu />
      ) : location?.pathname.includes("nurse") ? (
        <NurseMenu />
      )  : (
        <ProvidersMenu />
      )}
    </>
      


// :location?.pathname.includes("scribe") ? (
//         <ScribeMenu />
//       )






  );
};

export default MenuLists;
